import { Routes, Route } from "react-router";
import BrandsMain from "Modules/brands/views/main";
import BrandOverview from 'Modules/brands/views/overview';
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const BrandsView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "brnd") && <Route path="list" element={<BrandsMain />} />}
                {HasPermission(user, "brnd") && <Route path="overview/:id" element={<BrandOverview />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default BrandsView;